import type {StructureItemBody} from './StructureItemBody';

export type CreateTypeOfControlSettings = {
  name: string;
  key?: string;
  validation: CreateTypeOfControlSettings.validation;
  showEmptyFields: boolean;
  items: Array<StructureItemBody>;
};

export namespace CreateTypeOfControlSettings {
  export enum validation {
    VALIDATE = 'VALIDATE',
    NON_VALIDATE = 'NON_VALIDATE',
  }
}
